import moment from 'moment'
import qs from 'qs'
import conf from '../../../conf'
import backendStyle from '../../../backendStyle'

export default {
  newInstance (router, i18n) {
    return {
      isWx: /MicroMessenger/i.test(navigator.userAgent),
      isAliPay: /alipayclient/i.test(navigator.userAgent),
      isCloudPay: /UnionPay/i.test(navigator.userAgent),
      isYZF: /Bestpay/i.test(navigator.userAgent),
      isWebkit: /Webkit/i.test(navigator.userAgent),
      isChrome: /Chrome/i.test(navigator.userAgent),
      isMobile: !!('ontouchstart' in window),
      isAndroid: /Android/i.test(navigator.userAgent),
      isSafari: /Safari/i.test(navigator.userAgent),
      isIE: document.documentMode,
      isIE9: (() => {
        if (document.documentMode) {
          const browser = navigator.appName
          const bVersion = navigator.appVersion
          const version = bVersion.split(';')
          const trimVersion = version[1].replace(/[ ]/g, '')
          return browser === 'Microsoft Internet Explorer' && trimVersion === 'MSIE9.0'
        }
        return false
      })(),
      random (min, max) {
        return Math.random() * (max - min) + min
      },
      trimString (val) {
        if (!val) {
          return val
        }
        return val.replace(/(^\s*)|(\s*$)/g, '')
      },
      array2arrayx (array, oneLineCount) {
        const len = array.length
        const lineNum = len % 4 === 0 ? len / 4 : Math.floor((len / 4) + 1)
        const result = []
        for (let i = 0; i < lineNum; i++) {
          const temp = array.slice(i * oneLineCount, i * oneLineCount + oneLineCount)
          result.push(JSON.parse(JSON.stringify(temp)))
        }
        return result
      },
      getUuid (len, radix) {
        const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
        const uuid = []

        radix = radix || chars.length

        if (len) {
          for (let i = 0; i < len; i++) {
            uuid[i] = chars[0 | Math.random() * radix]
          }
        } else {
          uuid[8] = '-'
          uuid[13] = '-'
          uuid[18] = '-'
          uuid[23] = '-'
          uuid[14] = '4'

          for (let i = 0; i < 36; i++) {
            if (!uuid[i]) {
              const r = 0 | Math.random() * 16
              uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
            }
          }
        }

        return uuid.join('')
      },
      getNumber (val) {
        if (val == null) {
          return null
        }
        const x = val.replace(/[^0-9-.]/ig, '') * 1

        if (Number.isNaN(x)) {
          return null
        }
        return x
      },
      coverEmail (str) {
        if (!str || typeof str !== 'string') {
          return str
        }

        const startIndex = 0
        const endIndex = str.lastIndexOf('@') || str.length

        const s = str.substring(startIndex, endIndex)
        const len = Math.ceil(s.length / 2)

        let cov = ''
        for (let i = 0; i < s.length - len; i++) {
          cov += '*'
        }

        return s.substring(0, len) + cov + str.substring(endIndex)
      },
      coverMobile (str) {
        if (!str || typeof str !== 'string') {
          return str
        }

        return `${str.substring(0, 3)}****${str.substring(str.length - 4, str.length)}`
      },
      blob2data (blob, callback) {
        const reader = new FileReader()
        reader.onload = (e) => {
          callback(e.target.result)
        }
        reader.readAsDataURL(blob)
      },
      file2data (file, callback) {
        const reader = new FileReader()
        reader.onload = () => {
          const image = new Image()
          image.onload = () => {
            const canvas = document.createElement('canvas')
            const ctx = canvas.getContext('2d')
            canvas.height = image.height
            canvas.width = image.width
            ctx.drawImage(image, 0, 0)
            const dataURL = canvas.toDataURL('image/png')

            callback(dataURL)
          }
          image.src = reader.result
        }
        reader.readAsDataURL(file)
      },
      triggerInputFile ($ref) {
        const ie = navigator.appName === 'Microsoft Internet Explorer'

        if (ie) {
          $ref.click()
        } else {
          const a = document.createEvent('MouseEvents')
          a.initEvent('click', true, true)
          $ref.dispatchEvent(a)
        }
      },
      seperateNumber (value, precision = 0) {
        if (!value) {
          if (!precision) {
            return 0
          }
          let p = '.'
          for (let i = 0; i < precision; i++) {
            p += '0'
          }
          return 0 + p
        }
        let result = ''
        value = `${value}`
        const valueArray = value.split('.')
        const integerStr = `${valueArray[0]}`

        let counter = -1
        for (let i = integerStr.length - 1; i >= 0; i--) {
          counter++
          if (counter === 3) {
            result = `${integerStr[i]},${result}`
            counter = 0
          } else {
            result = integerStr[i] + result
          }
        }
        if (!precision) {
          return result
        }
        let p = '.'
        for (let i = 0; i < precision; i++) {
          if (valueArray.length > 1 && valueArray[1].length > i) {
            p += valueArray[1][i]
          } else {
            p += '0'
          }
        }
        return result + p
      },
      setScale (scale) {
        const metas = document.getElementsByTagName('head')[0].getElementsByTagName('meta')
        for (let i = 0; i < metas.length; i++) {
          if (metas[i].name === 'viewport') {
            metas[i].content = `width=device-width,initial-scale=${scale},minimum-scale=${scale},maximum-scale=${scale},user-scalable=no`
          }
        }
      },
      autoDay (millisecond, units) {
        // 毫秒
        let temp = millisecond
        let result = [temp % 1000]

        // 秒
        temp = (temp - temp % 1000) / 1000
        result = [temp % 60].concat(result)

        // 分
        temp = (temp - temp % 60) / 60
        result = [temp % 60].concat(result)

        // 时
        temp = (temp - temp % 60) / 60
        result = [temp % 24].concat(result)

        // 天
        temp = (temp - temp % 24) / 24
        result = [temp].concat(result)

        let str = ''
        for (let i = 0; i < result.length && i < units.length; i++) {
          if (units[i] !== '' && result[i] > 0) {
            str = str + result[i] + units[i]
          }
        }
        return str
      },
      getParamFromUrl (name) {
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
        let href = (window.location.href.split('?')[1] || '')
        if (href.endsWith('#/')) {
          href = href.substring(0, href.length - 2)
        }
        const r = href.match(reg)
        if (r != null) return unescape(r[2]); return null
      },
      getParam (url, name) {
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
        let href = (url.split('?')[1] || '')
        if (href.endsWith('#/')) {
          href = href.substring(0, href.length - 2)
        }
        const r = href.match(reg)
        if (r != null) return unescape(r[2]); return null
      },
      getQueryVariable (variable) {
        if (window.location.search === '') return undefined
        const query = window.location.search.substring(1)
        const queryArray = query.split('&')
        let code = ''
        for (let i = 0; i < queryArray.length; i++) {
          console.log('queryArray', queryArray[i])
          const item = queryArray[i]
          const [key, value] = item.split('=')
          if (key === variable) {
            code = value
          }
        }
        return code
      },
      getUrlParam (name) {
        // 获取参数
        const url = window.location.search
        // 正则筛选地址栏
        const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
        // 匹配目标参数
        const result = url.substr(1).match(reg)
        // 返回参数值
        return result ? decodeURIComponent(result[2]) : null
      },
      jumpCallbackAfterAuth (code) {
        let callback = window.localStorage.getItem('callback') || ''

        if (window.sessionStorage.getItem('callback')) {
          window.sessionStorage.setItem('callback01', callback)
        }
        if (window.sessionStorage.getItem('callback01')) {
          window.sessionStorage.setItem('callback001', callback)
        }
        window.localStorage.removeItem('callback')
        window.sessionStorage.setItem('callback', callback)
        if (callback.endsWith('#/')) {
          callback = callback.substring(0, callback.length - 2)
        }

        if (callback.indexOf('?') === -1) {
          callback = `${callback}?code=${code}`
        } else {
          const oldCode = this.getParam(callback, 'code') || ''
          if (oldCode || callback.indexOf('code=') > -1) {
            callback = callback.replace(`code=${oldCode}`, `code=${code}`)
          } else {
            callback = `${callback}&code=${code}`
          }
        }

        if (callback.startsWith('?')) {
          if (process.env.VUE_APP_NAME === 'qyw-portal') {
            callback = '/login'
          } else {
            callback = `${router.options.mode === 'hash' ? '/#' : ''}/login`
          }
        }
        window.location.href = callback
      },
      jumpCallbackAfterLogin () {
        console.log('jumpCallbackAfterLogin')
        let callback = window.localStorage.getItem('callback') || ''
        window.localStorage.removeItem('callback')

        if (window.location.href.indexOf('/xadmin') > -1 && callback.indexOf('/xadmin') === -1) {
          callback = ''
        }
        console.log('callback', callback)
        if (callback && callback !== '' && callback !== 'null' && callback !== 'undefined') {
          console.log('lllljiushiwan')
          window.location.href = callback
        } else {
          const code = this.getParamFromUrl('code')
          console.log('code：', code)
          console.log('homeRouter', conf.homeRouter)
          if (code) {
            router.push({ name: conf.homeRouter, query: { code } })
          } else {
            router.push({ name: conf.homeRouter })
          }
        }
      },
      setCallbackBeforeAuth (callback) {
        callback = callback || window.location.href
        window.localStorage.setItem('callback', this.removeAuth(callback))
      },
      removeAuth (href) {
        if (href.indexOf('?') === -1) {
          return href
        }
        const code = this.getParam(href, 'code') || ''
        href = href.replace(`?code=${code}&`, '?')
        href = href.replace(`?code=${code}`, '')
        href = href.replace(`&code=${code}`, '')

        const state = this.getParam(href, 'state') || ''
        href = href.replace(`?state=${state}&`, '?')
        href = href.replace(`?state=${state}`, '')
        href = href.replace(`&state=${state}`, '')

        const appId = this.getParam(href, 'appId') || ''
        href = href.replace(`?appId=${appId}&`, '?')
        href = href.replace(`?appId=${appId}`, '')
        href = href.replace(`&appId=${appId}`, '')

        return href
      },
      listParamFromUrl () {
        const result = []
        const search = window.location.href.split('?')[1] || ''
        if (search) {
          const params = search.split('&')
          if (params) {
            for (let i = 0; i < params.length; i++) {
              const values = params[i].split('=')
              if (values[0] !== 'code' && values[0] !== 'state') {
                result.push(`${values[0]}=${this.getParamFromUrl(values[0])}`)
              }
            }
          }
        }
        return result
      },
      exportFile (requestInfo) {
        if (requestInfo.params) {
          requestInfo.params = Object.assign({}, requestInfo.params)
        } else {
          requestInfo.params = {}
        }

        backendStyle[process.env.VUE_APP_BACKENDER].joinToken(requestInfo.params)

        if (conf.apiMode === 'cors') {
          window.open(`${process.env.VUE_APP_API_URL + requestInfo.url}?${qs.stringify(requestInfo.params)}`)
        } else {
          window.open(`${conf.apiBase + requestInfo.url}?${qs.stringify(requestInfo.params)}`)
        }
      },
      dateFormat (val, format = 'YYYY-MM-DD HH:mm:ss') {
        if (!val) {
          return val
        }
        return moment(val).format(format)
      },
      filterArray (myArray, recursiveKey, filterCondition, mapCondition) {
        if (!myArray || myArray.length === 0) {
          return myArray
        }

        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i][recursiveKey] && myArray[i][recursiveKey].length > 0) {
            myArray[i][recursiveKey] = this.filterArray(myArray[i][recursiveKey], recursiveKey, filterCondition, mapCondition)
          }
        }

        if (typeof mapCondition === 'function') {
          return myArray.filter(d => filterCondition(d)).map(d => mapCondition(d))
        }
        return myArray.filter(d => filterCondition(d))
      },
      getResponseError (res) {
        return backendStyle[process.env.VUE_APP_BACKENDER].renderError(res, i18n)
      },
      wrapResponse (res, noLoginFn) {
        return backendStyle[process.env.VUE_APP_BACKENDER].judgeResponse(res, noLoginFn, router)
      },
      // 减法
      floatSub (arg1, arg2) {
        let r1; let r2
        try {
          r1 = arg1.toString().split('.')[1].length
        } catch (e) { r1 = 0 }
        try {
          r2 = arg2.toString().split('')[1].length
        } catch (e) { r2 = 0 }
        console.log('r1, r2: ', r1, r2)
        // eslint-disable-next-line no-restricted-properties
        const m = Math.pow(10, Math.max(r1, r2))
        console.log('m: ', m)
        // 动态控制精度长度
        const n = (r1 >= r2) ? r1 : r2
        console.log('n: ', n)
        console.log('arg1， arg2: ', arg1, arg2)
        console.log('结果: ', ((arg1 * m - arg2 * m) / m).toFixed(n))
        return ((Number(arg1) * m - Number(arg2) * m) / m).toFixed(n)
      }
    }
  }
}
